(() => {
  const meta = document.querySelector('meta[name="soily-sale-ends-at"]');
  if (meta?.dataset.soilySaleActive?.trim() !== 'true') return;
  const deadline = Number(meta?.content) * 1000;
  if (!Number.isFinite(deadline) || deadline <= 0) return;
  let timer;
  let ended = false;
  const updateCart = async () => {
    const cart = document.querySelector('[data-soily-cart-section]');
    if (!cart || !cart.querySelector('.cart-summary')) return;
    cart.setAttribute('data-soily-cart-prices-pending', '');
    const note = document.createElement('p');
    note.className = 'shipping-note';
    note.setAttribute('role', 'status');
    note.textContent = cart.dataset.soilyCartRefreshLabel;
    cart.querySelector('.cart-summary').prepend(note);
    let submitting = false;
    cart.querySelector('form')?.addEventListener('submit', () => { submitting = true; }, { once: true });
    try {
      const url = new URL(location.href);
      url.searchParams.set('sections', cart.dataset.soilyCartSection);
      url.searchParams.set('_soily_sale_refresh', String(deadline));
      const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) return;
      const sections = await response.json();
      const html = sections[cart.dataset.soilyCartSection];
      if (typeof html !== 'string' || submitting || !cart.isConnected) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html');
      const selectors = ['.line-total', '[data-soily-cart-discounts]', '[data-soily-cart-totals]'];
      for (const selector of selectors) {
        if (cart.querySelectorAll(selector).length !== fresh.querySelectorAll(selector).length) return;
      }
      if (fresh.querySelector('[data-soily-sale-only]')) return;
      for (const selector of selectors) {
        const targets = cart.querySelectorAll(selector);
        fresh.querySelectorAll(selector).forEach((source, index) => { targets[index].innerHTML = source.innerHTML; });
      }
      cart.removeAttribute('data-soily-cart-prices-pending');
      note.remove();
    } catch {}
  };
  const expire = () => {
    if (ended) return;
    ended = true;
    document.documentElement.classList.add('soily-sale-ended');
    document.querySelectorAll('[data-soily-regular-price]').forEach(node => {
      node.textContent = node.dataset.soilyRegularPrice;
    });
    document.querySelectorAll('[data-soily-after-sale]').forEach(node => {
      node.textContent = node.dataset.soilyAfterSale;
    });
    document.querySelectorAll('option[data-soily-regular-label]').forEach(option => {
      option.dataset.price = option.dataset.regularPrice;
      option.dataset.sale = 'false';
      option.textContent = option.dataset.soilyRegularLabel;
    });
    document.querySelectorAll('[data-product] [data-variant]').forEach(select => {
      const price = select.closest('[data-product]')?.querySelector('[data-price]');
      if (price && select.selectedOptions[0]) price.textContent = select.selectedOptions[0].dataset.regularPrice;
    });
    document.querySelectorAll('[data-soily-sale-schema]').forEach(script => {
      try {
        const json = JSON.parse(script.textContent);
        const regular = JSON.parse(script.dataset.soilyRegularPrices);
        for (const variant of json.hasVariant || []) {
          const price = regular[variant.productID];
          if (Number.isFinite(price) && variant.offers) {
            variant.offers.price = price;
            delete variant.offers.priceValidUntil;
          }
        }
        script.textContent = JSON.stringify(json).replaceAll('<', '\\u003c');
      } catch {}
    });
    document.querySelectorAll('[data-soily-vsl]').forEach(vsl => {
      if (vsl.contains(document.activeElement)) document.querySelector('[data-add], [data-main-buy]')?.focus();
      vsl.querySelectorAll('video').forEach(video => video.pause());
      vsl.hidden = true;
    });
    updateCart();
  };
  const check = () => {
    clearTimeout(timer);
    if (Date.now() >= deadline) expire();
    else timer = setTimeout(check, Math.min(deadline - Date.now(), 2147483647));
  };
  window.addEventListener('pageshow', check);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
  check();
})();
